import React from "react";
import Button from "./components/MgyButton/MgyButton";
import Icon from "./components/MgyIcon/MgyIcon";

/**
 * Check empty/null/undefined value
 * @param v
 * @returns {boolean}
 */
function empty (v) {
	return v === undefined || v === null || v === '';
}

/**
 *
 * @param type
 * @param message
 * @constructor
 */

const notify = (type, message) => {

	type = type === 'information' ? 'info' : type;

	const icon = ({
		error: 'close',
		warning: 'warning',
		success: 'check'
	})[type] ?? 'info';

	window.toast[type](message, {
		position: "top-right",
		autoClose: 1000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined,
		icon: <Button className={"mgy-btn-notification mgy-btn-notification-" + type }>
			<Icon name={icon} onClick={() =>{}} className={"mgy-icon-notification mgy-icon-notification-" + type}/>
		</Button>
	});
}

window.notify = notify;
window.empty = empty;

export {empty, notify};